import { useState } from 'react'
import { NotificationPopup } from '@renderforest/rf-components'

// Notification centre popup, rendered once when the editor opens. It fetches
// notifications for the 'v-editor' surface itself; if there are no unread ones
// it closes immediately and renders nothing, so it is safe to always mount.
const NotificationCenter = () => {
  const [isOpen, setIsOpen] = useState(true)

  return (
    <NotificationPopup
      isOpen={isOpen}
      currentSurface="v-editor"
      onClose={() => setIsOpen(false)}
    />
  )
}

export default NotificationCenter
